import controller from './related-posts.controller';
import template from './templates/related-posts.view.html';
import templateAD from './templates/related-posts-adaptative.view.html';

let RelatedPostsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        categories: '<'
    }
};

function changeTemplate() {
    if (__env.adaptative) {
        return templateAD;
    } else {
        return template;
    }
}

export default RelatedPostsComponent;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/blog/related-posts/related-posts.component.js
 **/